import React, { Suspense, useEffect, useState } from 'react';
import { renderRoutes } from 'react-router-config';
import PropTypes from 'prop-types';
import { LinearProgress } from '@material-ui/core';
import useStyles from './styles';
import AuthService from '../../services/auth.service';
import { NavBar, TopBar } from '../../components';
import { createStructuredSelector } from 'reselect';
import { isLoggedInSelector } from '../../appContainer/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { validateTokenAction } from '../../appContainer/actions';
import { useHistory } from 'react-router';

const stateSelector = createStructuredSelector({
  isLoggedIn: isLoggedInSelector,
});

const LoginRequired = props => {
  const { route } = props;
  const classes = useStyles();
  const [openNavBarMobile, setOpenNavBarMobile] = useState(false);
  const { isLoggedIn } = useSelector(stateSelector);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    const auth = new AuthService();
    const token = auth.getToken();
    if (!token) {
      history.push('/auth/login');
    } else {
      dispatch(validateTokenAction.Request({ token }));
    }
  }, [isLoggedIn]);

  const handleNavBarMobileOpen = () => {
    setOpenNavBarMobile(true);
  };

  const handleNavBarMobileClose = () => {
    setOpenNavBarMobile(false);
  };

  return (
    <div className={classes.root}>
      <TopBar className={classes.topBar} onOpenNavBarMobile={handleNavBarMobileOpen} />
      <div className={classes.container}>
        <NavBar className={classes.navBar} onMobileClose={handleNavBarMobileClose} openMobile={openNavBarMobile} />
        <main className={classes.content}>
          {isLoggedIn ? <Suspense fallback={<LinearProgress />}>{renderRoutes(route.routes)}</Suspense> : null}
        </main>
      </div>
    </div>
  );
};

LoginRequired.propTypes = {
  route: PropTypes.object,
};

export default LoginRequired;
